import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { Checklist } from '@/domain/models/Checklist'
import { Result } from '@/domain/protocols/Result'

import type { IChecklistRepository } from '@/data/ChecklistRepository/IChecklistRepository'

const getSortableTime = (checklist: Checklist): number => {
  const updatedAt = checklist.updatedAt instanceof Date ? checklist.updatedAt.getTime() : NaN
  if (!Number.isNaN(updatedAt)) return updatedAt

  const createdAt = checklist.createdAt instanceof Date ? checklist.createdAt.getTime() : NaN
  if (!Number.isNaN(createdAt)) return createdAt

  return 0
}

export class LoadChecklistsUseCase implements UseCase<boolean, Promise<Result<Checklist[]>>> {
  private repository: IChecklistRepository

  constructor(repository?: IChecklistRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IChecklistRepository>(InjectionTokens.ChecklistRepository)
  }

  async execute(forceRefresh = false): Promise<Result<Checklist[]>> {
    try {
      const result = await this.repository.getChecklists(forceRefresh)
      if (result.isFailure) return Result.fail(result.error)

      // Copied before sorting: the repository hands out its own cache array, which must keep the
      // order the server sent it in.
      const sortedChecklists = [...result.getValue()].sort((a, b) => getSortableTime(b) - getSortableTime(a))

      return Result.ok(sortedChecklists)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
